import React from "react";
import { Card, Row, Col, Space, Typography } from "antd";
import { DragOutlined } from "@ant-design/icons";
import RenderInput from "./RenderInput";
import RenderAddButton from "./RenderAddButton";
import RenderDeleteButton from "./RenderDeleteButton";
import RenderSelect from "./RenderSelect";
import CardTitle from "./CardTitle";

const RenderInputMemo = React.memo(RenderInput);
const RenderAddButtonMemo = React.memo(RenderAddButton);
const RenderDeleteButtonMemo = React.memo(RenderDeleteButton);
const RenderSelectMemo = React.memo(RenderSelect);

const { Text } = Typography;

const InnerCard = ({
  onInputChange,
  index,
  nestedIndex,
  itemId,
  deleteSection,
  dragToggle,
  data,
  keyTitle,
  placeholder,
  //   key,
  isHeading,
  element,
  renderSelectedItem,
  addOption,
  addSubSection,
  newId,
}) => {
  const handleInputChange = React.useCallback((element, parentId, childId, nestedChildId, isCheckbox) => {
    onInputChange(element, parentId, childId, nestedChildId, isCheckbox);
  }, []);
  
  return (
    <>
      <Card
        style={{ marginBottom: 16 }}
        type="inner"
        title={
          <CardTitle
            onInputChange={handleInputChange}
            index={index}
            keyTitle={keyTitle}
            value={
              data.subSectionsList[nestedIndex].sub_heading_title ||
              data.subSectionsList[nestedIndex].title
            }
            itemId={itemId}
            nestedIndex={nestedIndex}
            deleteSection={deleteSection}
            dragToggle={dragToggle}
            placeholder={placeholder}
            newId={newId}
          />
        }
        extra={dragToggle && <DragOutlined />}
      >
        {!isHeading && !dragToggle && (
          <>
            <Row gutter={[16, 16]}>
              <Col span={2}></Col>
              <Col span={6}>
                <Space>
                  <Text strong>Type</Text>
                </Space>
              </Col>
              <Col span={4}>
                <Space>
                  <Text strong>Required</Text>
                </Space>
              </Col>
              <Col span={4}>
                <Space>
                  <Text strong>Width</Text>
                </Space>
              </Col>
              <Col span={2}></Col>
            </Row>
            <Row gutter={[16, 16]}>
              <Col span={2}></Col>
              <Col span={6}>
                <RenderSelectMemo
                  value={element.widget}
                  id={itemId}
                  nestedId={nestedIndex}
                  renderSelectedItem={renderSelectedItem}
                  onInputChange={handleInputChange}
                />
              </Col>
              <Col span={4}>
                <RenderInputMemo
                  index={index}
                  onInputChange={handleInputChange}
                  keyTitle={"required"}
                  placeholder="Required"
                  value={element.required}
                  id={itemId}
                  newId={nestedIndex}
                  nestedIndex={null}
                  isCheckbox={true}
                  //   key={key}
                />
              </Col>
              <Col span={4}>
                <RenderSelectMemo
                  value={element.widget}
                  id={itemId}
                  nestedId={nestedIndex}
                  span={true}
                  renderSelectedItem={renderSelectedItem}
                  onInputChange={handleInputChange}
                />
              </Col>
              <Col span={2}></Col>
            </Row>

            {!dragToggle &&
              element.options.length !== 0 &&
              element.options.map((nestedItem, elementNestedIndex) => (
                <Row gutter={[16, 16]}>
                  <Col span={6}></Col>
                  <Col span={6}>
                    <RenderInputMemo
                      index={index}
                      onInputChange={handleInputChange}
                      keyTitle={"title"}
                      placeholder="Option Text"
                      value={nestedItem.title}
                      id={itemId}
                      newId={nestedIndex}
                      nestedIndex={elementNestedIndex}
                    />
                  </Col>
                  <Col span={6}>
                    <RenderDeleteButtonMemo
                      title="Delete"
                      id={itemId}
                      childId={nestedIndex}
                      nestedChildId={elementNestedIndex}
                      isOption={true}
                      deleteSection={deleteSection}
                    />
                  </Col>
                </Row>
              ))}
            {
              <Row gutter={[16, 16]}>
                <Col span={6}></Col>
                <Col span={6}>
                  {(!dragToggle && element.widget === "RadioGroupWidget") ||
                  element.widget === "CheckboxGroupWidget" ? (
                    <RenderAddButtonMemo
                      title="Add Option"
                      isHeading={false}
                      id={itemId}
                      childId={nestedIndex}
                      position={null}
                      isOption={true}
                      addOption={addOption}
                      addSubSection={addSubSection}
                    />
                  ) : null}
                </Col>
              </Row>
            }
          </>
        )}
      </Card>
    </>
  );
};

export default InnerCard;
